<div class="input-group">
    <div class="input-group field-input-group">
        <input class="form-control field-input" placeholder="Search" 
            [(ngModel)]="query" (ngModelChange)="queryChange()">
        <div class="field-input-group-actions">
            @if (query.length === 0) {
                <div class="btn btn-transparent">
                    <svg ycnIcon name="icon-search"></svg>
                </div>
            } @else {
                <button class="btn btn-transparent btn-clear ng-scope" (click)="clearInput()"
                    ycnTooltip tooltipPlacement="bottom" tooltipTitle="Clear The Field">
                    <svg ycnIcon name="icon-close"></svg>
                </button>
            }
        </div>
    </div>
</div>
